export enum GenelcoSpreadsheetFileUploadSteps {
  FileUpload = 0,
  Received = 1,
  Processing = 2,
  ProcessingComplete = 3,
  Completed = 4,
}
